export default __webpack_public_path__ + "static/media/analytics.ef2429f5.svg";